const ArtworkCategory = `
  id
  name
  goodsCode
`;

export default ArtworkCategory;
